/*
 * @Author: hewie.sung
 * @Date: 2022-04-26 20:22:32
 * @LastEditTime: 2022-08-20 14:44:16
 * @Description:
 */
// HTTP工具类
import axios from 'axios';
import { Notify, Dialog } from 'vant';
import store from '../store';
import Cookies from 'js-cookie';

axios.defaults.baseURL = process.env.DEV_PROXY_TARGET;
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
};
axios.defaults.withCredentials = false;

export default class http {
  static async request(method, url, data, contentType = {}, loading = true, blob = false, timeout) {
    const apiURL = url;
    const param = {
      url,
      method,
      data: method === 'GET' ? null : data,
      headers: {
        "Content-Type": contentType || "application/x-www-form-urlencoded",
        "Authorization": `Token ${Cookies.get('token')}` || undefined,
      },
      timeout: timeout || 30000,
      // `onUploadProgress` 允许为上传处理进度事件
      // onUploadProgress(progressEvent) {
      //   const { loaded, total } = progressEvent;
      //   const newUploadProgress = Math.round(loaded / total * 10 * 100) / 10;
      //   store.commit('mutation_fileUploadProgress', newUploadProgress);
      //   if (newUploadProgress === 100) {
      //     setTimeout(() => {
      //       store.commit('mutation_fileUploadProgress', 0);
      //     }, 2000);
      //   }
      // },
    };
    // 群众监管不传token
    if (Cookies.get('userRole') === 'common') {
      delete param.headers["Authorization"];
    }
    if (contentType && contentType.constructor === Object && contentType.hasOwnProperty('headers')) param.headers = contentType.headers
    if (contentType && contentType.constructor === Object && contentType.hasOwnProperty('responseType')) param.responseType = contentType.responseType
    if (loading) {
      //
    }
    try {
      param.headers = { ...param.headers };
      const res = await axios(param);
      // 接口不弹窗白名单
      // const whiteList = [];
      if (blob) {
        if (res.status === 200) {
          return res;
        } else {
          Notify({ type: 'warning', message: 'Download failed!' });
        }
      } else {
        if (this.isSuccess(res)) {
          return res.data;
        }
        if (res.status === 403) {
          const url = window.location.origin;
          window.location.href = url;
        }
        if (res.data?.error === 401) {
          // 未登录，可处理免登陆逻辑
          Dialog.alert({
            title: res.data?.error,
            message: res.data?.message,
            theme: 'round-button',
            confirmButtonColor: '#1989fa',
          }).then(() => {
            // on close
            const url = window.location.origin;
            window.location.href = url;
          });
        } else if (res.data?.error !== 0) {
          Notify({ type: 'warning', message: res.data?.message || 'Server Exception!' });
        }
        return res.data;
      }
    } catch (e) {
      console.log(JSON.parse(JSON.stringify(e)));
      const errRes = JSON.parse(JSON.stringify(e));
      if (errRes.response.status === 403 || errRes.response.status === 401 || (errRes.response.data?.error === -1 && !(apiURL.startsWith('/api/task/?') || apiURL.startsWith('/api/notice/?')))) {
        // 未登录，可处理免登陆逻辑
        Dialog.alert({
          title: `error:${errRes.response.status}`,
          message: errRes.response.data?.message,
          theme: 'round-button',
          confirmButtonColor: '#1989fa',
        }).then(() => {
          // on close
          Cookies.remove('token');
          Cookies.remove('role');
          Cookies.remove('user_info');
          window.location.pathname = '/';
        });
      } else if (errRes.response.data?.error !== 0) {
        if (apiURL.startsWith('/api/task/?') || apiURL.startsWith('/api/notice/?')) {
          store.commit('mutation_listStatus', { loading: false, finished: true })
          return Notify({ type: 'success', message: 'Loaded successfully!' });
        }
        Notify({
          type: 'warning', message: errRes.response.data?.message || 'Server Exception!'
        });
      }
    }
  }

  /**
   * @description: 判断请求是否成功
   * @param {*} res
   * @return {*}
   */
  static isSuccess(res) {
    const status = res.status;
    // 请求错误
    if (status === 401) {
      //
    } else if (status !== 200) {
      return false;
    }
    const result = res.data;
    return result && (result.error === 0 || result.error === 1 || result.error === 200 || result.error === 'success');
  }

  static requestException(res) {
    const error = {};
    error.status = res.status;
    const result = res.data;
    if (result) {
      console.log('result', result);
      error.serverCode = result.code;
      error.message = (result.message && result.message.indexOf('timeout') !== -1) ? 'The request timeout!' : result.message;
      error.serverData = result;
    }
    return error;
  }

  static get(url, data, headers, isJson, loading = true, timeout) {
    return this.request('GET', url, data, 'application/x-www-form-urlencoded', loading, false, timeout);
  }

  static Blob(url, data) {
    return this.request('GET', url, data, {
      responseType: 'blob',
      headers: { Accept: 'application/octet-stream' }
    }, true, true);
  }

  static put(url, data, isJson, loading = true, timeout) {
    return this.request('PUT', url, data, isJson ? 'application/json;charset=utf-8' : undefined, loading, false, timeout);
  }

  static post(url, data, isJson, loading = true, timeout) {
    return this.request('POST', url, data, isJson ? 'application/json;charset=utf-8' : undefined, loading, false, timeout);
  }

  static upload(url, data, contentType, loading = true, timeout) {
    return this.request('POST', url, data, 'multipart/form-data', loading, false, timeout);
  }

  static postJSON(url, data, isJson, loading = true, timeout) {
    return this.request("POST", url, data, 'application/json;charset=utf-8', loading, false, timeout);
  }

  static patch(url, data, isJson, loading = true, timeout) {
    return this.request('PATCH', url, data, isJson ? 'application/json;charset=utf-8' : undefined, loading, false, timeout);
  }

  static delete(url, data, isJson, loading = true, timeout) {
    return this.request('DELETE', url, data, isJson ? 'application/json;charset=utf-8' : undefined, loading, false, timeout);
  }

  static file(url, timeout) {
    const surl = url.split('filenames=')[1] ? `${url.split('filenames=')[0]}filenames=${encodeURIComponent(url.split('filenames=')[1])}` : url
    return this.request('GET', surl, null, {
      responseType: 'blob',
      headers: { Accept: 'application/octet-stream' }
    }, null, true, timeout)
  }
}